<template>
  <form
    class="grid text-left md:text-center md:mt-16 items-start content-start w-full md:w-auto"
    @submit.prevent="customerLogin"
  >
    <h1 class="text-3xl font-bold hidden md:block">Mobile Number</h1>
    <fieldset class="grid gap-1 md:gap-5">
      <label for="mobile" class="font-semibold">Please enter your mobile number</label>
      <input
        type="tel"
        inputmode="numeric"
        placeholder="Mobile Number"
        class="p-3 rounded font-semibold"
        minlength="10"
        maxlength="10"
        pattern="[6-9][0-9]{9}"
        v-model="phone"
        required
        @keypress="isNumber"
        name="mobile"
        id="mobile"
      />
    </fieldset>
    <p class="text-errorColor text-sm mt-4 text-left" v-if="errorMessage">{{ errorMessage }}</p>
    <custom-button
      variant="primary"
      class="mt-8 md:mt-20 justify-center font-extrabold"
      type="submit"
      :loading="loading"
    >Send OTP</custom-button>
  </form>
    <transition name="fade" v-if="VueAppDevChangesServer === 'staging' && this.phone === '9100000000'">
      <Modal v-show="isOpen" @close-modal="isOpen = false">
        <form
          class="px-10 py-6 bg-greyBackground rounded-md grid gap-6 w-full"
          @submit.prevent=""
        >
        <div class="flex justify-between gap-4">
          <Title variant="medium" class="col-span-full whitespace-nowrap">Now Change Dev Server from UI Side</Title>
          <img class="cursor-pointer" @click="isOpen= false, phone= undefined" src="../assets/cross-primary.svg" alt=""/>
        </div>
          <p class="text-sm font-normal">
            Dev Server Currently Deployed on:-
          <span class="font-semibold text-sm text-primary">
            {{hostname}}
          </span> <br/>
            Point on server:-
          <span class="font-semibold text-sm text-primary">
            {{checkDevActiveServer.replace(/.+\/\/|www.|\..+/g, '')}}
          </span>
          </p>
          <div class="grid gap-4 md:grid-cols-2 grid-cols-1">
            <radio-button
              label="generic-dev"
              :labelWidth="true"
              name="generic-dev"
              id="generic-dev"
              :required="true"
              :value="genericDevServerUrl"
              @change="selectServer"
              :checked="isCheckedGenericDev"
            />
            <radio-button
              label=" generic-dev-fb-1"
              :labelWidth="true"
              name="fb-1"
              id="fb-1"
              :required="true"
              :value="GenericDevFb1ServerUrl"
              @change="selectServer"
              :checked="isCheckedGenericDevFb1"
            />
          </div>
          <div class="grid gap-4 md:grid-cols-3 grid-cols-1">
            <radio-button
              label="phase1"
              :labelWidth="true"
              name="phase1"
              id="phase1"
              :required="true"
              :value="Genericphase1ServerUrl"
              @change="selectServer"
              :checked="isCheckedGenericphase1"
            />
            <radio-button
              label="fb-2"
              :labelWidth="true"
              name="fb-2"
              id="fb-2"
              :required="true"
              :value="GenericFb2ServerUrl"
              @change="selectServer"
              :checked="isCheckedGenericFb2"
            />
            <radio-button
              label="fb-3"
              :labelWidth="true"
              name="fb-3"
              id="fb-3"
              :required="true"
              :value="GenericDevFb3ServerUrl"
              @change="selectServer"
              :checked="isCheckedGenericDevFb3"
            />
          </div>

          <div class="grid gap-4 md:grid-cols-2 grid-cols-1">
            <radio-button
              label="phase2"
              :labelWidth="true"
              name="phase2"
              id="phase2"
              :required="true"
              :value="GenericPhase2ServerUrl"
              @change="selectServer"
              :checked="isCheckedPhase2"
            />
            <radio-button
              label=" retailapi-dev"
              :labelWidth="true"
              name="retailapi"
              id="retailapi"
              :required="true"
              :value="GenericRetailapiServerUrl"
              @change="selectServer"
              :checked="isCheckedRetailapi"
            />
          </div>
          <section class="grid">
            <custom-button
                variant="secondary"
                class="font-extrabold"
                @click.prevent="resetServer"
                :disabled="isResetEnable"
              >Reset UI Side Server &nbsp;<span class="text-xs font-normal">({{checkDevActiveServer.replace(/.+\/\/|www.|\..+/g, '')}})</span></custom-button>
          </section>
        </form>
      </Modal>
    </transition>
</template>
<script>
import { mapGetters } from 'vuex';
import Cookies from 'js-cookie';
import CustomButton from '../components/CustomButton.vue';
import Modal from '../components/Modal.vue';
import Title from '../components/Title.vue';
import RadioButton from '../components/RadioButton.vue';

export default {
  name: 'MobileNo',
  components: {
    CustomButton,
    Modal,
    Title,
    RadioButton,
  },
  computed: {
    ...mapGetters(['sessionId']),
  },
  data() {
    return {
      params: {
        device: {
          deviceType: 'browser',
          deviceMake: 'web',
          deviceModel: 'web',
          os: 'web',
          osVersion: 'web',
          identifierType: 'ip',
          identificationNumber: undefined,
        },
        location: {
          latitude: 28.4223649,
          longitude: 77.0357388,
        },
        source: 'web',
        utmParameters: {
          source: undefined,
          medium: undefined,
          campaign: undefined,
          channel: 'web',
        },
        onBoardingFlow: 'WEB LONG',
      },
      phone: undefined,
      loading: undefined,
      errorMessage: undefined,
      VueAppDevChangesServer: process.env.VUE_APP_ENV,
      checkDevActiveServer: process.env.VUE_APP_API_ROOT,
      isOpen: undefined,
      isCheckedGenericDev: undefined,
      isCheckedGenericDevFb1: undefined,
      isCheckedGenericphase1: undefined,
      isCheckedGenericFb2: undefined,
      isCheckedGenericDevFb3: undefined,
      isCheckedPhase2: undefined,
      isCheckedRetailapi: undefined,
      genericDevServerUrl: 'https://generic-dev.epaylater.in',
      GenericDevFb1ServerUrl: 'https://generic-dev-fb-1.epaylater.in',
      Genericphase1ServerUrl: 'https://generic-dev-phase1.epaylater.in',
      GenericFb2ServerUrl: 'https://generic-dev-fb-2.epaylater.in',
      GenericDevFb3ServerUrl: 'https://generic-dev-fb-3.epaylater.in',
      GenericPhase2ServerUrl: 'https://generic-dev-phase2.epaylater.in',
      GenericRetailapiServerUrl: 'https://retailapi-dev.epaylater.in',
      hostname: window.location.hostname,
      isResetEnable: undefined
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // localhost
      localStorage.removeItem('phone');
      Cookies.remove('mobileNo');
      Cookies.remove('authToken');
      // serverSite
      Cookies.remove('mobileNo', { path: '/', domain: '.epaylater.in' });
      Cookies.remove('authToken', { path: '/', domain: '.epaylater.in' });
      const sessionId = this.$route.query.session;
      this.$registerProperties({
        platform: 'web',
        m_code: undefined
      });
      if (sessionId) {
        this.$store.commit('CREATE_SESSION', { sessionId });
        if (this.$route.query.otpSent) {
          this.$router.push({ name: 'Verify Otp' });
        }
      } else {
        if (Array.isArray(this.$route.query.utm_source)) {
          this.params.utmParameters.source = Array.isArray(this.$route.query.utm_source)
          ? this.$route.query.utm_source[0]
          : 'direct';
        } else {
          this.params.utmParameters.source = this.$route.query.utm_source
          ? this.$route.query.utm_source
          : 'direct';
        }
        if (Array.isArray(this.$route.query.utm_medium)) {
          this.params.utmParameters.medium = Array.isArray(this.$route.query.utm_medium)
          ? this.$route.query.utm_medium[0]
          : 'direct';
        } else {
          this.params.utmParameters.medium = this.$route.query.utm_medium
          ? this.$route.query.utm_medium
          : 'direct';
        }
        if (Array.isArray(this.$route.query.utm_campaign)) {
          this.params.utmParameters.campaign = Array.isArray(this.$route.query.utm_campaign)
          ? this.$route.query.utm_campaign[0]
          : 'direct';
        } else {
          this.params.utmParameters.campaign = this.$route.query.utm_campaign
          ? this.$route.query.utm_campaign
          : 'direct';
        }
        this.getCurrentLocation();
      }
    },
    getCurrentLocation() {
      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            this.params.location.latitude = pos.coords.latitude;
            this.params.location.longitude = pos.coords.longitude;
            this.referralStart();
          },
          () => {
            this.referralStart();
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
          }
        );
      } else {
        this.referralStart();
      }
    },
    referralStart() {
      const name = this.$route.query.marketplaceName;
      const params = {
        marketplaceInfo: {
          name,
        },
        callbackUrl: this.$route.query.callbackUrl || window.location.origin,
        source: {
          source: this.$route.query.utm_source || 'direct',
          medium: this.$route.query.utm_medium || 'direct',
          campaign: this.$route.query.utm_campaign || 'direct',
          channel: 'web',
        },
        location: this.params.location,
      };
      const formData = new FormData();
      formData.append('data', JSON.stringify(params));
      if (name) {
        this.$store
          .dispatch('referralStart', formData)
          .then((result) => {
            const { sessionId } = result.session;
            this.$store.commit('CREATE_SESSION', { sessionId });
          })
          .catch(() => {});
      }
    },
    customerLogin() {
      this.$trackEvent(this.$mixpanelEvent.MOBILE_ENTERED);
      const guarantorQueryParams = this.$route.query.redirect.toLocaleLowerCase();
      if (this.VueAppDevChangesServer === 'staging' && this.phone === '9100000000') {
        if (!JSON.parse(localStorage.getItem('server_Data'))) {
          this.isResetEnable = true;
        }
        this.isOpen = true;
        this.checkRecentActivateServerByUISide();
      } else {
        this.loading = true;
        if (this.sessionId) {
          if (guarantorQueryParams && guarantorQueryParams.includes("guarantor")) {
            this.guarantorSendOtp();
          } else {
            this.sendOtp();
          }
        } else {
          this.sessionCreate()
            .then(() => {
              if (guarantorQueryParams && guarantorQueryParams.includes("guarantor")) {
                this.guarantorSendOtp();
              } else {
                this.sendOtp();
              }
            })
            .catch(() => { });
        }
      }
    },
    sessionCreate() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('sessionCreate', this.params)
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    guarantorSendOtp() {
      const params = {
        phoneNumber: this.phone,
        sessionId: this.sessionId,
      };
      this.$store
        .dispatch('guarantorLogin', params)
        .then((result) => {
          this.loading = false;
          const tncAccepted = result?.tncAccepted;
          this.$router.push({
            name: 'Verify Otp',
            params: { phone: this.phone },
            query: { ...this.$route.query, tncAccepted },
          });
        })
        .catch((err) => {
          this.errorMessage = err.message;
          this.loading = false;
        });
    },
    sendOtp() {
      const params = {
        phone: this.phone,
        sessionId: this.sessionId,
        referrerCode: this.$route.query.referral_code,
      };
      this.$store
        .dispatch('customerLogin', params)
        .then((response) => {
          this.loading = false;
          this.$router.push({
            name: 'Verify Otp',
            params: { phone: this.phone },
            query: { ...this.$route.query, ...response },
          });
        })
        .catch((err) => {
          this.errorMessage = err.message;
          this.loading = false;
        });
    },
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    selectServer(event) {
      const serverData = {
        serverUrl: event.target.value,
        serverActivateNumber: this.phone,
        serverCheckFlag: this.VueAppDevChangesServer
      };
      this.$moshaToast(`Server Change Successfully From UI Side to ${event.target.value.replace(/.+\/\/|www.|\..+/g, '')} !`, { type: 'success', showIcon: 'true' });
      localStorage.setItem('server_Data', JSON.stringify(serverData));
        setTimeout(() => {
            window.location.reload();
        }, 3000);
      this.isOpen = false;
    },
    checkRecentActivateServerByUISide() {
      const checkActiveServerUISide = JSON.parse(localStorage.getItem('server_Data'))?.serverUrl;
      if (checkActiveServerUISide === this.genericDevServerUrl) {
        this.isCheckedGenericDev = true;
        this.isCheckedGenericDevFb1 = false;
        this.isCheckedGenericphase1 = false;
        this.isCheckedGenericFb2 = false;
        this.isCheckedGenericDevFb3 = false;
        this.isCheckedPhase2 = false;
        this.isCheckedRetailapi = false;
      } else if (checkActiveServerUISide === this.GenericDevFb1ServerUrl) {
        this.isCheckedGenericDevFb1 = true;
        this.isCheckedGenericphase1 = false;
        this.isCheckedGenericFb2 = false;
        this.isCheckedGenericDev = false;
        this.isCheckedGenericDevFb3 = false;
        this.isCheckedPhase2 = false;
        this.isCheckedRetailapi = false;
      } else if (checkActiveServerUISide === this.Genericphase1ServerUrl) {
        this.isCheckedGenericphase1 = true;
        this.isCheckedGenericFb2 = false;
        this.isCheckedGenericDev = false;
        this.isCheckedGenericDevFb1 = false;
        this.isCheckedGenericDevFb3 = false;
        this.isCheckedPhase2 = false;
        this.isCheckedRetailapi = false;
      } else if (checkActiveServerUISide === this.GenericFb2ServerUrl) {
        this.isCheckedGenericFb2 = true;
        this.isCheckedGenericDevFb1 = false;
        this.isCheckedGenericphase1 = false;
        this.isCheckedGenericDev = false;
        this.isCheckedGenericDevFb3 = false;
        this.isCheckedPhase2 = false;
        this.isCheckedRetailapi = false;
      } else if (checkActiveServerUISide === this.GenericDevFb3ServerUrl) {
        this.isCheckedGenericDevFb3 = true;
        this.isCheckedGenericFb2 = false;
        this.isCheckedGenericDevFb1 = false;
        this.isCheckedGenericphase1 = false;
        this.isCheckedGenericDev = false;
        this.isCheckedPhase2 = false;
        this.isCheckedRetailapi = false;
      } else if (checkActiveServerUISide === this.GenericPhase2ServerUrl) {
        this.isCheckedPhase2 = true;
        this.isCheckedGenericDevFb3 = false;
        this.isCheckedGenericFb2 = false;
        this.isCheckedGenericDevFb1 = false;
        this.isCheckedGenericphase1 = false;
        this.isCheckedGenericDev = false;
        this.isCheckedRetailapi = false;
      } else if (checkActiveServerUISide === this.GenericRetailapiServerUrl) {
        this.isCheckedRetailapi = true;
        this.isCheckedPhase2 = false;
        this.isCheckedGenericDevFb3 = false;
        this.isCheckedGenericFb2 = false;
        this.isCheckedGenericDevFb1 = false;
        this.isCheckedGenericphase1 = false;
        this.isCheckedGenericDev = false;
      }
    },
    resetServer() {
      localStorage.removeItem('server_Data');
      this.$moshaToast(`Reset Server From UI side Default Deployed Server Activated ${this.checkDevActiveServer.replace(/.+\/\/|www.|\..+/g, '')} !`, { type: 'default', showIcon: 'true' });
      setTimeout(() => {
          window.location.reload();
      }, 3000);
      this.isOpen = false;
    }
  },
};
</script>
